import {
  FETCHED_DOCUMENTS,
  START_FETCHING_DOCUMENTS,
  FETCHED_DOCUMENT,
  START_FETCHING_DOCUMENT,
  START_PUBLISHING_DOCUMENT,
  PUBLISHED_DOCUMENT,
  START_UPDATING_DOCUMENT,
  UPDATED_DOCUMENT,
  UPDATE_DOCUMENT,
  DELETE_DOCUMENTS,
  SET_USER_DATA,
  SET_TABLE_PAGE_SIZE,
  SET_CURRENT_PAGE,
  SET_FILTERED_DOCUMENTS,
  DELETE_FILTERED_DOCUMENTS,
} from '../actionTypes';

import { DocumentType } from './../../types/AppTypes';

interface InitialState {
  documents: DocumentType[];
  loading: boolean;
  error: any;
  message: any;
  user: any;
  tablePageSize: number;
  currentPage: number;
  filteredDocuments: DocumentType[];
}

const initialState: InitialState = {
  documents: [],
  loading: false,
  error: null,
  message: null,
  user: null,
  tablePageSize: 10,
  currentPage: 1,
  filteredDocuments: []
};

// eslint-disable-next-line import/no-anonymous-default-export
export default function (state = initialState, action: any) {
  switch (action.type) {
    case START_FETCHING_DOCUMENTS:
      return {
        ...state,
        documents: [],
        error: null,
        message: null,
        loading: true,
      };
    case FETCHED_DOCUMENTS: {
      const { documents, error, message } = action.payload;
      return {
        ...state,
        documents,
        error,
        message,
        loading: false,
      };
    }
    case START_FETCHING_DOCUMENT:
      return {
        ...state,
        error: null,
        message: null,
        loading: true,
      };
    case FETCHED_DOCUMENT: {
      const { error, message } = action.payload;
      return {
        ...state,
        error,
        message,
        loading: false,
      };
    }
    case START_PUBLISHING_DOCUMENT: {
      return {
        ...state,
        error: null,
        message: null,
        loading: true,
      };
    }
    case START_UPDATING_DOCUMENT: {
      return {
        ...state,
        error: null,
        message: null,
        loading: true,
      };
    }
    case UPDATED_DOCUMENT: {
      const { error, message, id, text } = action.payload;
      const newDocuments = state.documents.map((d: DocumentType) =>
        d.documentId === id ? { ...d, text, state: 'PENDING' } : d,
      );
      return {
        ...state,
        error,
        message,
        documents: newDocuments,
        loading: false,
      };
    }
    case PUBLISHED_DOCUMENT: {
      const { id } = action.payload;
      return {
        ...state,
        documents: state.documents.map((d: DocumentType) =>
          d.documentId === id ? { ...d, state: 'PUBLISHED' } : d,
        ),
      };
    }
    case UPDATE_DOCUMENT:
      const { document } = action.payload;
      return {
        ...state,
        documents: state.documents.map((d: DocumentType) =>
          d.documentId === document.documentId ? document : d,
        ),
      };    
    case DELETE_DOCUMENTS:
      const { documentIds } = action.payload;
      return {
        ...state,
        documents: state.documents.filter(doc => !documentIds.includes(doc.documentId)),
      };    
    case SET_USER_DATA: {
      return {
        ...state,
        user: action.payload,
      };
    }
    case SET_TABLE_PAGE_SIZE: {
      return {
        ...state,
        tablePageSize: action.payload,
      };
    }
    case SET_CURRENT_PAGE: {
      return {
        ...state,
        currentPage: action.payload,
      };
    }
    case SET_FILTERED_DOCUMENTS: {
      return {
        ...state,
        filteredDocuments: action.payload,
      };
    }
    case DELETE_FILTERED_DOCUMENTS:
      const { documentIds: docIds } = action.payload;
      return {
        ...state,
        filteredDocuments: state.filteredDocuments.filter(doc => !docIds.includes(doc.documentId)),
      };
    default:
      return state;
  }
}
